module.exports = __webpack_public_path__ + "img/yeosu_gallery0.c14071ec.jpg";